<template>
  <div>
    <main>
      <div class="Kyuyo_MainArea">
        <b-container fluid>
          <div class="WorkM_MailResendTitleArea">
            <div class="TitleItem_TitleLabel"><b-icon icon="calendar-check" class="mr-2"></b-icon>振替残管理</div>
          </div>
          <div class="SubstitudeHoliday">
            <!--検索欄-->
            <div class="SubstitudeHolidayConditionArea">
              <div class="ConditionRow">
                <label class="labelTitle pt-0 pl-2" v-if="!emptyCheck(targetDate)">{{ targetDate }}時点</label>
                <label class="spacer" v-if="!emptyCheck(targetDate)"></label>
                <label class="labelTitle pt-0 pl-2" v-if="validityPeriod > 0">{{ validityPeriod }}日以内</label>
                <label class="labelTitle pt-0 pl-2" v-else>1年以内</label>
              </div>
              <div class="ConditionRow">
                <div class="ConditionEachArea d-flex flex-wrap">
                  <div class="d-flex align-items-center mt-2">
                    <label class="labelTitle pt-0 pl-2">本社/支店</label>
                    <b-select class="selectSectionPart" 
                    :options="optionOffice_group" 
                    v-model="selectOffice" 
                    @change="getAttendanceListOffice()" 
                    :items="optionOffice" 
                    value-field="office_code" 
                    text-field="office_name"
                    ></b-select>
                  </div>
                  <div class="d-flex align-items-center mt-2">
                    <label class="labelTitle pt-0 pl-2">部</label>
                    <b-select 
                    class="selectSectionPart" 
                    :options="optionPart_group" 
                    v-model="selectPart" 
                    @change="getAttendanceListPart()" 
                    :items="optionPart" 
                    value-field="key" 
                    text-field="part_name"></b-select>
                  </div>
                  <div class="d-flex align-items-center mt-2">
                    <label class="labelTitle pt-0 pl-2">課</label>
                    <b-select 
                    class="selectSectionPart" 
                    :options="optionSection_group" 
                    v-model="selectSection" 
                    @change="getAttendanceListSection()" 
                    :items="optionSection" 
                    value-field="key" 
                    text-field="section_name"
                    ></b-select>
                  </div>
                </div>
              </div>
            </div>
            <!--一覧-->
            <div class="SubstitudeHolidayListArea small">
              <b-table class="SubstitudeHolidayListTable mb-0" 
              :items="listData" 
              :fields="listFields" 
              small 
              sticky-header 
              @row-clicked="clickDate" 
              striped
              bordered>
                <template #cell(index)="data">
                  <label style="margin-bottom: 0;">{{ data.index + 1 }}</label>
                </template>
                <template #cell(workingOnHolidaysTime)="data">
                  <label style="margin-bottom: 0;">{{ data.item.workingOnHolidaysTime }}</label>
                  <label style="margin-bottom: 0;">（</label>
                  <label style="min-width:46px;margin-bottom: 0;">{{ data.item.workingOnHolidaysDay }}</label>
                  <label style="margin-bottom: 0;">日）</label>
                </template>
                <template #cell(substituteHolidaysTime)="data">
                  <label style="margin-bottom: 0;">{{ data.item.substituteHolidaysTime }}</label>
                  <label style="margin-bottom: 0;">（</label>
                  <label style="min-width:46px;margin-bottom: 0;">{{ data.item.substituteHolidaysDay }}</label>
                  <label style="margin-bottom: 0;">日）</label>
                </template>
                <template #cell(remainSubstituteHolidaysTime)="data">
                  <label style="margin-bottom: 0;">{{ data.item.remainSubstituteHolidaysTime }}</label>
                  <label style="margin-bottom: 0;">（</label>
                  <label style="min-width:53px;margin-bottom: 0;">{{ data.item.remainSubstituteHolidaysDay }}</label>
                  <label style="margin-bottom: 0;">日）</label>
                </template>
              </b-table>
            </div>
          </div>
        </b-container>
      </div>
    </main>
    <TransferMatchModal 
    ref="TransferMatchModal"
    :loginUserId="loginUserId"
    :office="officeName"
    :part="departmentName"
    :section="sectionName"
    :shainCd="shainCd"
    :name="shainName"
    :targetDate="targetDate"
    :validityPeriod="validityPeriod"
    v-on:emitModal="emitModal"
    ></TransferMatchModal>
  </div>
</template>

<script>
import config from "../../const/config";
import TransferMatchModal from"../../components/Modal/TransferMatchModal";
export default {
  name: "SubstitudeHolidayManage",
  components:{TransferMatchModal},
  data(){
    return{
      systemVersion: null,
      loginUserId: null,
      listFields: [
        {
          key: 'index',
          class: 'col_index',
          thClass: 'table-header',
          label: '#',
          sortable: false,
        },
        {
          key: 'officeName',
          class: 'col_office',
          thClass: 'table-header',
          label: "本社/支店",
        },
        {
          key: 'departmentName',
          class: 'col_part',
          thClass: 'table-header',
          label: "部",
        },
        {
          key: 'sectionName',
          class: 'col_section',
          thClass: 'table-header',
          label: "課",
        },
        {
          key: 'shainCd',
          class: 'col_shaincd',
          thClass: 'table-header',
          label: "社員番号",
        },
        {
          key: 'shainName',
          class: 'col_name',
          thClass: 'table-header',
          label: "社員名",
        },
        {
          key: 'workingOnHolidaysTime',
          class: 'col_substitute_date',
          thClass: 'table-header',
          label: "休日出勤",
        },
        {
          key: 'substituteHolidaysTime',
          class: 'col_substitute_date',
          thClass: 'table-header',
          label: "振替休日",
        },
        {
          key: 'remainSubstituteHolidaysTime',
          class: 'col_substitute_date',
          thClass: 'table-header',
          label: "振替残",
        },
      ],
      listData:[],
      // 本社/支店選択
      optionOffice: [],
      selectOffice: null,
      // 部
      optionPart: [],
      selectPart: {"office_code":null, "part_code":null},
      // 課
      optionSection: [],
      selectSection: {"office_code":null, "part_code":null, "section_code":null},

      officeName:null,
      departmentName:null,
      sectionName:null,
      shainCd:null,
      shainName:null,
      targetDate:null,
      validityPeriod:0,
    };
  },
  computed: {
    // 支店変更時に使用
    defaultPart: function(){
        return {"office_code":this.selectOffice, "part_code":null};
    },
    // 部署変更時に使用
    defaultSection: function(){
        return {"office_code":this.selectOffice, "part_code":this.selectPart.part_code, "section_code":null};
    },
    // 支店リスト
    optionOffice_group: function(){
        let arr = [];
        arr = arr.concat({"office_code":null, "office_name":"（すべて）"});
        if(this.optionOffice !== undefined){
            arr = arr.concat(this.optionOffice);
        }
        return arr;
    },
    // 部署リスト
    optionPart_group: function(){
        let arr = [];
        arr = arr.concat({"key":this.defaultPart, "part_name":"（すべて）"});
        if(this.optionPart !== undefined){
            if(this.selectOffice == null){
                arr = arr.concat(this.optionPart);
                return arr;
            }
            let partListByselectedOffice =  this.optionPart.filter((part)=>{
                return part.key.office_code===this.selectOffice
            });
            arr = arr.concat(partListByselectedOffice);
            console.debug(JSON.stringify(arr));
        }
        return arr;
    },
    // 課リスト
    optionSection_group: function(){
      let arr = [];
      arr = arr.concat({"key":this.defaultSection, "section_name":"（すべて）"});
      if(this.optionSection !== undefined){
        if(this.selectPart.office_code == null && this.selectPart.part_code == null){
          arr = arr.concat(this.optionSection);
          return arr;
        }
        let sectionListByselectedPart = this.optionSection.filter((section)=>{
          if(this.selectPart.part_code == null){
            return section.key.office_code===this.selectOffice
          }
          else{
            return section.key.office_code===this.selectPart.office_code && section.key.part_code===this.selectPart.part_code
          }
        });
        arr = arr.concat(sectionListByselectedPart);
      }
      return arr;
    }
  },
  watch: {},
  mounted: function(){
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    
    // 条件一覧取得
    this.getSearchConditionAPI();
    this.getSubstituteHolidayManageInfo(null,null,null);
  },
  methods: {
    // 行クリックで振休ポップアップを表示
    clickDate: function(dateData){
      console.log("dateData：" + JSON.stringify(dateData));
      this.officeName = dateData.officeName;
      this.departmentName = dateData.departmentName;
      this.sectionName = dateData.sectionName;
      this.shainCd = dateData.shainCd;
      this.shainName = dateData.shainName;
      this.$refs.TransferMatchModal.openModal();
    },
    // モーダルクローズ時処理
    emitModal: function() {
      if (this.selectSection.section_code != null) {
        this.getSubstituteHolidayManageInfo(this.selectSection.office_code, this.selectSection.part_code, this.selectSection.section_code);
      } else if (this.selectPart.part_code != null) {
        this.getSubstituteHolidayManageInfo(this.selectPart.office_code, this.selectPart.part_code, null);
      } else if (this.selectOffice != null) {
        this.getSubstituteHolidayManageInfo(this.selectOffice, null, null);
      } else {
        this.getSubstituteHolidayManageInfo(null,null,null);
      }
    },
    // 本社/支店セレクトボックスを選択したら一覧を再取得
    getAttendanceListOffice: function(){
      this.getSubstituteHolidayManageInfo(this.selectOffice, null, null);
      this.selectPart = this.defaultPart;
      this.selectSection = this.defaultSection;
    },
    getAttendanceListPart:function(){
      this.getSubstituteHolidayManageInfo(this.selectPart.office_code, this.selectPart.part_code, null);
      this.selectSection = this.defaultSection;
    },
    getAttendanceListSection:function(){
      this.getSubstituteHolidayManageInfo(this.selectSection.office_code, this.selectSection.part_code, this.selectSection.section_code);
    },
    // 検索条件に合った一覧をAPIから取得
    getSubstituteHolidayManageInfo: function(officeCd,departmentCd,sectionCd){
      // APIから振替残管理画面の一覧を取得
      let paramList = {
        managerShainCd: this.loginUserId,
        officeCd: officeCd,
        departmentCd: departmentCd,
        sectionCd: sectionCd,
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.SUBSTITUTE_HOLIDAY_MANAGE_SHAIN_LIST, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setSubstituteHolidayManageInfo(response.container);
          }
          else{
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    setSubstituteHolidayManageInfo: function(item){
      // 取得した一覧をセット
      this.listData = item.shainInfoList;
    },
    // 本社/支店選択、部選択、課選択をAPIから取得する
    getSearchConditionAPI: function(){
      // 送るパラメータ確認
      let paramList = {
        managerShainCd: this.loginUserId,
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.SUBSTITUTE_HOLIDAY_MANAGE, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setOption(response.container);
          }
          else{
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // 本社/支店選択、部選択、課選択をセットする
    setOption: function(items){
        console.debug(items);
        // 本社/支店一覧にセット
        this.optionOffice = items.officeList;
        console.debug("optionOffice：" + JSON.stringify(this.optionOffice));
        // 部選択一覧にセット
        this.optionPart = items.partList;
        console.debug("optionPart：" + JSON.stringify(this.optionPart));
        // 課選択一覧にセット
        this.optionSection = items.sectionList;
        console.debug("optionSection：" + JSON.stringify(this.optionSection));

        // 有効期間文字
        this.targetDate = items.targetDate;
        // 有効期間種別
        this.validityPeriod = items.dateOfExpiry;
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  },
}
</script>
<style>
.SubstitudeHoliday{
  padding: 0 1rem;
}
.SubstitudeHolidayConditionArea{
  padding: 1rem;
  margin-bottom: 1rem;
  border-top: 1px solid rgb(82, 75, 75);
  border-bottom: 1px solid rgb(82, 75, 75);
}
.SubstitudeHolidayListArea{
  max-height: 750px;
  max-width: 1365px;
  border-bottom: 1px solid rgb(212, 212, 212);
}
.SubstitudeHolidayListTable{
  /* min-height: 670px; */
  /* min-width: 1090px; */
  /* overflow-x: hidden; */
  max-height: 60vh!important;
  overflow-x: auto;
}
.SubstitudeHolidayListTable th.table-header{
  font-weight: bold;
  background-color: rgb(204, 211, 255) !important;
  text-align: center !important;
}
.SubstitudeHolidayListTable td{
  text-align: center;
}
.col_index{
  text-align: right !important;
  width: 3%;
  min-width:35px;
}
.col_office{
  text-align: left !important;
  width: 9%;
  min-width:120px;
}
.col_part{
  text-align: left !important;
  width: 9%;
  min-width:120px;
}
.col_section{
  text-align: left !important;
  width: 9%;
  min-width:120px;
}
.col_shaincd{
  text-align: right !important;
  width: 5%;
  min-width:55px;
}
.col_name{
  text-align: left !important;
  width: 14%;
  min-width:160px;
}
.col_substitute_date{
  text-align: right !important;
  width: 10% !important;
  min-width:150px;
}
</style>